export const mapVariants = (variants) => {
  return variants.map((variant) => {
    return {
      ...variant,
      Sellable: Number(variant.inventory) > 0,
      imgs: variant.image_url,
      Color: variant.option1,
      id: variant.variant_id,
      'Product-sku': variant.sku ? variant.sku : '',
    };
  });
};
